export const RECOMMENDED_MOVIE = 'RECOMMENDED_MOVIE';
export const SEARCHED_MOVIE = 'SEARCHED_MOVIE';
